'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var index = require('../app-constants/index.js');
var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var ChevronLeftIcon = _interopDefault(require('@material-ui/icons/ChevronLeft'));
var MenuIcon = _interopDefault(require('@material-ui/icons/Menu'));
var styledComponents = require('./styled-components.js');

var CollapsibleDrawer = function (props) {
    var anchor = props.anchor, icon = props.icon, children = props.children, imageUrl = props.imageUrl, openDrawerTitle = props.openDrawerTitle, imageAlt = props.imageAlt;
    var isDesktop = window.innerWidth > index.LARGE_SCREEN;
    var _a = React.useState(isDesktop), open = _a[0], setDrawerState = _a[1];
    return (React__default.createElement("div", null,
        React__default.createElement(styledComponents.OpenDrawerButton, { open: open, "aria-label": openDrawerTitle, title: openDrawerTitle, onClick: function () { return setDrawerState(true); } }, icon()),
        React__default.createElement(core.Drawer, { variant: 'persistent', anchor: anchor, open: open, "data-testid": 'drawer menu' },
            React__default.createElement(styledComponents.DrawerHeader, null,
                React__default.createElement(styledComponents.LogoContainer, null,
                    React__default.createElement("a", { href: imageUrl },
                        React__default.createElement("img", { src: 'images/legwork-2019-logo-01.svg', alt: imageAlt }))),
                React__default.createElement(core.IconButton, { onClick: function () { return setDrawerState(false); } },
                    React__default.createElement(ChevronLeftIcon, null))),
            React__default.createElement(core.Divider, null),
            children)));
};
CollapsibleDrawer.defaultProps = {
    anchor: 'left',
    icon: function () { return React__default.createElement(MenuIcon, null); },
    drawerStateChange: function () { },
    imageLocation: index.LEGWORK_LOGO,
    openDrawerTitle: 'Open Drawer Menu',
    imageAlt: 'Menu Logo',
};

module.exports = CollapsibleDrawer;
